<template>
  <div class="pricesheetpage">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <CommonHead></CommonHead>
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="pricesheet">
	  <h1 class="account-mobile">Price Sheet by Book</h1>
          <div class="choosebook">
            <h3>Choose a Book</h3>
            <div class="selectedbooks">
                <v-select 
                    :clearable="false"
                    :multiple="true"
                    :options="pricesheet"
                    class="booksdrop"
                    @input="selectSelection"
                    v-model="form.books"
                    :reduce="pricesheet => pricesheet.SUNTAFITEMATTRIBUTEDESC"
                    label="SUNTAFITEMATTRIBUTEDESC"
                    placeholder="Select"
                ></v-select> 
                <div class="selectedfilter" v-if="form.books.length > 0">
                    <b-form-tags v-model="form.books" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.books"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                    </div>
                <a v-if="form.books.length > 0" class="clearfilter" href="javascript:;" @click="resetBooksDrop">Clear all</a>
            </div>
          </div>
          <div class="radio-options">
            <md-radio v-model="form.radio" name="retail" value="retail">Suggested Retail</md-radio>
            <md-radio v-model="form.radio" name="qty" value="qty">Retail Plus Additional %</md-radio>
            <div v-show="form.radio === 'qty'" class="diffqty">
                <div class="samediv quantity">
                    <span>Qty:</span>
                    <div class="qtydiv">
                    <span @click="decrement()"> - </span>
                    <input v-model="form.quantity" readonly>
                    <span @click="increment()" class="lastspan"> + </span>
                    </div>
                </div>
            </div>
            <md-radio v-model="form.radio" name="price" value="price">Retail Plus Additional $</md-radio>
            <div v-show="form.radio === 'price'" class="diffqty">
                <div class="samediv quantity">
                    <span>Qty:</span>
                    <div class="qtydiv">
                    <span @click="decrement1()"> - </span>
                    <input v-model="form.quantity1" readonly>
                    <span @click="increment1()" class="lastspan"> + </span>
                    </div>
                </div>
            </div>
            <b-button type="button" @click="onSubmit" variant="dark" squared>Find</b-button>
          </div>
          
          <div class="needhelp">
            <h3>Need Help?</h3>
            <div class="callwrite">
                <div class="callus">
                <h4>Call Us</h4>
                <a href="#">
                    <b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
                </a>
                <span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
                </div>
                <div class="writeus">
                <h4>Write to Us</h4>
                <a href="mailto:customerservice@rmcoco.com">
                    <b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
                </a>
                <span>We’ll get back to you within 24 hours.</span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    Loading,
    'v-select': vSelect
  },
  data() {
    return {
        form:{
            books:[],
            quantity:1,
            quantity1:1,
            radio:"retail"
        },
        pricesheet: [],
        isLoading: false,
        breadcrumb: [
            {
            text: "My Account",
            active: true
            }
        ]
        };
    },
    mounted(){
        this.getPricesheetBooks();
    },
    methods:{
        increment () {
            this.form.quantity++
        },
        decrement () {
        if(this.form.quantity === 1) {
            console.log('Negative quantity not allowed')
        } else {
            this.form.quantity--
        }   
        },
        increment1 () {
            this.form.quantity1++
        },
        decrement1 () {
            if(this.form.quantity1 === 1) {
                console.log('Negative quantity not allowed')
            } else {
                this.form.quantity1--
            }
        },
        selectSelection(){
            if(this.form.books.length < 1){
                $(".pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle").css("border-color","#f00");
            }else{
                $(".pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle").removeAttr("style");
            }
        },
        getPricesheetBooks(){
            this.$store.dispatch("loadPricesheetBooks").then(pricesheet => {
                this.pricesheet = pricesheet.data;
            });
        },
        resetBooksDrop(){
            this.form.books = [];
        },
        onSubmit(){
            let error = '';
            if(this.form.books.length < 1){
                $(".pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle").css("border-color","#f00");
                error += '1';
            }else{
                $(".pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle").removeAttr("style");
            }
            if(error == ''){
                this.isLoading = true;
                this.$notify({
                    text: "Generating pricelists",
                    type: "success",
                });
                this.$store.dispatch("loadPDFPricebyBooks",this.form).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'pricesheet.pdf');
                    document.body.appendChild(link);
                    link.click();
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            }
        }
    },
};
</script>
<style>
.pricesheet{
    min-height: 80vh;
    padding: 40px 0 0 40px;
    box-sizing: border-box;
    position: relative;
    margin-left: 26.3%;
    width: 100%;
}
.pricesheet .choosebook{
    width: 100%;
    border-radius: 0;
    border: none;
    max-width: 1110px;
    padding-right: 40px;
    box-sizing: border-box;
    display: inline-block;
}
.pricesheet .choosebook h3{
    text-align: left;
}
.pricesheet .radio-options .md-radio{
    width: 100%;
    margin-bottom: 20px !important;
}
.pricesheet .radio-options .samediv.quantity{
    margin-bottom: 10px;
}
.pricesheet .radio-options .samediv.quantity span{
    float: left;
    margin-top: 5px;
}
.pricesheet .btn-dark{
    width: 270px;
    margin-top: 25px;
}
.pricesheet .radio-options .samediv .qtydiv span{
  float: left;
  font-size: 18px;
  border: 1px solid #d2d2d2;
  margin: 0;
  height: 35px;
  line-height: 35px;
  padding: 0 8px;
  font-weight: 500;
  color: #303030;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  cursor: pointer;
}
.pricesheet .radio-options .samediv .qtydiv span.lastspan{
  -webkit-border-top-right-radius: 3px;
  -webkit-border-bottom-right-radius: 3px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomleft: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  line-height: 39px;
}
.pricesheet .radio-options .samediv .qtydiv input{
  float: left;
  max-width: 45px;
  font-size: 14px;
  height: 35px;
  text-align: center;
  border-top:1px solid #d2d2d2;
  border-bottom:1px solid #d2d2d2;
  border-left: 0;
  border-right: 0;
  font-weight: 500;
  color: #303030;
  padding-top: 6px;
}
.pricesheet .choosebook .selectedbooks{
    width: 100%;
    display: inline-block;
}
.pricesheet .choosebook .selectedbooks a{
    font-size: 12px;
    color: #303030;
    font-weight: normal;
    margin-left: 15px;
    margin-top: 10px;
    display: inline-block;
}
.pricesheet .choosebook .selectedbooks a:hover{
    text-decoration: none;
}
.pricesheet .choosebook .selectedbooks .selectedfilter{
    font-size: 12px;
    color: #303030;
    font-weight: normal;
    background: #ececec;
    box-sizing: border-box;
    padding: 10px 10px;
    float: left;
    border-radius: 3px;
    margin-left: 15px;
}
.pricesheet .choosebook .selectedbooks .selectedfilter a{
    margin-top: 0;
}
.pricesheet .choosebook .selectedbooks .selectedfilter a .closefilter{
    height: 10px;
    width:10px;
}
.pricesheet .booksdrop{
    max-width: 270px;
    margin-bottom: 20px;
    float:left;
}
.pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle{
    height: 40px;
}
.pricesheet .booksdrop.vs--searchable .vs__dropdown-toggle .vs__selected{
    display: none;
}
.pricesheet .choosebook .selectedbooks .selectedfilter .b-form-tags{
    margin: 0 !important;
    padding: 0;
}
.pricesheet .needhelp{
    padding: 35px;
    box-sizing: border-box;
    background: #ececec;
    position: relative;
    width: 75%;
    margin: 45px 0 75px 0;
    max-width: 610px;
    float: left;
}
.pricesheet .needhelp h3{
  text-align:left;
  margin-bottom: 30px;
}
.pricesheet .needhelp .callwrite {
  display: flex;
  justify-content: space-between;
}
.pricesheet .needhelp .callus h4,.pricesheet .needhelp .writeus h4{
    text-align: left;
    margin-bottom: 8px;
    font-weight: 600;
}
.pricesheet .needhelp a {
    font-size: 14px;
    line-height: 20px;
    margin-top: 12px;
    text-decoration: none;
    color: #303030;
    font-weight: normal;
    text-align: left;
    width: 100%;
}
.pricesheet .needhelp a:hover{
  text-decoration: none;
}
.pricesheet .needhelp a img {
  height: 14px;
  width: 14px;
  display: inline-block;
  margin: 0 10px 0 0;
}
.pricesheet .needhelp span {
  font-size: 12px;
  color: #777777;
  margin-top: 8px;
  display: inline-block;
  font-weight: normal;
}
@media only screen and (max-width: 1440px) {
    .pricesheet{margin-left: 390px;}
}
@media only screen and (max-width: 1360px) {
   .pricesheet{margin-left: 345px;}
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .pricesheet{margin-left: 300px;}
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.pricesheet{margin-left: 245px;}	
	.pricesheet .choosebook{
	    max-width: 100%;
		padding-right: 20px;
	}
	.pricesheet .needhelp{
		padding: 35px 20px;
		width: 100%;
		margin: 45px 0 75px 0;
		max-width: 460px;
	}
	.pricesheet .needhelp .callwrite{
		flex-wrap:wrap;
	}
	.pricesheet .needhelp a{
		width:100%;
		display:inline-block;
	}
	.pricesheet .needhelp .callus h4, .pricesheet .needhelp .writeus h4{
		margin-bottom:0;
	}
	.pricesheet .needhelp .callus{
		margin-bottom:20px
	}
	.pricesheet .radio-options {
		margin-top: 25px;
	}
}
@media only screen and (max-width:767px){
    .pricesheet {
        margin-left: 0;
        width: 100%;
        padding: 40px 20px 0 20px;
    }
    .pricesheet .choosebook{
        max-width: 100%;
        padding-right: 0;
    }
    .pricesheet .booksdrop{
        max-width: 100%;
    }
    .pricesheet .radio-options .md-radio{
        margin-right: 0 !important;
    }
    .pricesheet .btn-dark{
        width: 100%;
    }
    .pricesheet .needhelp{
      margin:0;
      width: 100%;
      margin: 20px auto 50px auto;
      max-width: 375px;
      padding: 35px 15px 45px 15px;
    }
    .pricesheet .needhelp .callwrite{
      flex-wrap: wrap;
    }
    .pricesheet .needhelp .callwrite .callus{
      margin-bottom: 20px;
    }
    .pricesheet .choosebook .selectedbooks .selectedfilter{
        margin-bottom: 20px;
        margin-left: 0;
    }
    .pricesheet .choosebook .selectedbooks button.btn.btn-link.btn-sm{
        position: relative;
        top:-2px;
    }
}
</style>